class PurchaseLimits {
  constructor() {
    this.currentVariantId = null;
    this.purchaseLimits = {};
    this.init();
  }

  init() {
    console.log('PurchaseLimits: Inizializzazione...');
    this.loadPurchaseLimits();
    this.bindEvents();
    // Ritarda il controllo iniziale per assicurarsi che tutto sia caricato
    setTimeout(() => this.checkInitialVariant(), 500);
  }

  loadPurchaseLimits() {
    const limitsElement = document.querySelector('[data-variant-purchase-limits]');
    if (limitsElement) {
      try {
        const limitsData = JSON.parse(limitsElement.textContent || '[]');
        limitsData.forEach(item => {
          this.purchaseLimits[item.variant_id] = item.limit;
        });
        console.log('Limiti di acquisto caricati:', this.purchaseLimits);
      } catch (error) {
        console.error('Errore nel caricamento dei limiti:', error);
      }
    }
  }

  bindEvents() {
    console.log('PurchaseLimits: Binding eventi...');
    
    // Ascolta i cambi di variante
    document.addEventListener('variant:change', async (e) => {
      console.log('PurchaseLimits: Evento variant:change ricevuto', e.detail);
      if (e.detail && e.detail.variant) {
        this.currentVariantId = e.detail.variant.id;
        await this.checkVariantLimit();
      }
    });
    
    // Ascolta anche l'evento Shopify standard
    document.addEventListener('shopify:variant:change', async (e) => {
      console.log('PurchaseLimits: Evento shopify:variant:change ricevuto', e.detail);
      if (e.detail && e.detail.variant) {
        this.currentVariantId = e.detail.variant.id;
        await this.checkVariantLimit();
      }
    });

    // Ascolta i cambi nei selettori di variante
    const variantSelectors = document.querySelectorAll('[data-variant-selector], [data-variant-select]');
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        setTimeout(() => this.checkCurrentVariant(), 100);
      });
    });

    // Controlla quando cambia la quantità - selettori più specifici
    const quantityInputs = document.querySelectorAll('[data-quantity-input], input[name="quantity"], .quantity__input, .quantity__field, #product-quantity-input, input[type="number"][name="quantity"]');
    console.log('PurchaseLimits: Input quantità trovati:', quantityInputs.length);
    quantityInputs.forEach(input => {
      console.log('PurchaseLimits: Binding su input:', input);
      
      // Controllo immediato al bind
      this.checkQuantityLimit(input);
      
      input.addEventListener('input', () => this.checkQuantityLimit(input));
      input.addEventListener('change', () => this.checkQuantityLimit(input));
      input.addEventListener('keyup', () => this.checkQuantityLimit(input));
    });
    
    // Monitora anche i pulsanti +/-
    document.addEventListener('click', (e) => {
      if (e.target.closest('.quantity__minus, .quantity__plus, .quantity__button')) {
        console.log('PurchaseLimits: Click su pulsante quantità');
        setTimeout(() => {
          const input = e.target.closest('.quantity-selector, .quantity__wrapper, quantity-counter, .quantity')?.querySelector('input[type="number"], .quantity__input');
          if (input) {
            console.log('PurchaseLimits: Controllo quantità dopo click pulsante');
            this.checkQuantityLimit(input);
          }
        }, 50);
      }
    });
    
    // Intercetta l'invio del form per controllare il limite
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (form.querySelector('[name="add"]') || form.action?.includes('/cart/add')) {
        console.log('PurchaseLimits: Intercettato submit form add to cart');
        
        const quantityInput = form.querySelector('input[name="quantity"]');
        const variantInput = form.querySelector('input[name="id"]');
        
        if (variantInput && quantityInput) {
          const variantId = variantInput.value;
          const quantity = parseInt(quantityInput.value) || 1;
          
          if (this.purchaseLimits[variantId]) {
            e.preventDefault(); // Blocca temporaneamente
            
            const limit = this.purchaseLimits[variantId];
            const currentInCart = await this.getVariantQuantityInCart(variantId);
            const maxAllowed = Math.max(0, limit - currentInCart);
            
            console.log(`PurchaseLimits: Submit check - Limite: ${limit}, Nel carrello: ${currentInCart}, Richiesti: ${quantity}, Max consentiti: ${maxAllowed}`);
            
            if (quantity > maxAllowed) {
              // Aggiusta la quantità e mostra errore
              quantityInput.value = maxAllowed;
              const message = this.translateMessage('canOnlyAdd', { remaining: maxAllowed, limit });
              this.showLimitWarning(message);
              
              if (maxAllowed > 0) {
                // Se possiamo aggiungere qualcosa, reinvia il form con la quantità corretta
                setTimeout(() => form.submit(), 1000);
              }
            } else {
              // Quantità OK, procedi con l'invio
              form.submit();
            }
          }
        }
      }
    });
  }

  async checkCurrentVariant() {
    // Trova l'ID della variante corrente - aggiungiamo più selettori
    const variantIdInput = document.querySelector('[name="id"]:checked, select[name="id"], input[name="id"][type="hidden"], input[name="id"]:not([type])');
    console.log('PurchaseLimits: Controllo variante corrente, input trovato:', variantIdInput);
    
    if (variantIdInput) {
      this.currentVariantId = variantIdInput.value;
      console.log('PurchaseLimits: ID variante corrente:', this.currentVariantId);
      await this.checkVariantLimit();
    } else {
      console.log('PurchaseLimits: Nessun input variante trovato');
    }
  }

  async checkInitialVariant() {
    // Controlla la variante iniziale al caricamento della pagina
    await this.checkCurrentVariant();
  }

  async checkVariantLimit() {
    if (!this.currentVariantId || !this.purchaseLimits[this.currentVariantId]) {
      this.clearLimitWarning();
      this.enableQuantityInput();
      return;
    }

    const limit = this.purchaseLimits[this.currentVariantId];
    const currentQuantityInCart = await this.getVariantQuantityInCart(this.currentVariantId);
    const remaining = Math.max(0, limit - currentQuantityInCart);

    console.log(`Variante ${this.currentVariantId}: Limite=${limit}, Nel carrello=${currentQuantityInCart}, Disponibili=${remaining}`);

    if (remaining === 0) {
      const message = this.translateMessage('limitReached', { limit });
      this.showLimitWarning(message);
      this.disableAddToCart();
    } else if (remaining < limit) {
      const message = this.translateMessage('canAddMore', { remaining, limit });
      this.showLimitWarning(message);
      this.updateQuantityMax(remaining);
    } else {
      this.clearLimitWarning();
      this.enableQuantityInput();
    }
  }

  async getVariantQuantityInCart(variantId) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      let totalQuantity = 0;
      
      // Conta TUTTI gli item con questa variante, indipendentemente dalle properties
      cart.items.forEach(item => {
        if (item.variant_id == variantId) {
          totalQuantity += item.quantity;
          console.log(`Trovato item con variante ${variantId}:`, item.title, 'Qty:', item.quantity, 'Properties:', item.properties);
        }
      });
      
      console.log(`Quantità TOTALE variante ${variantId} nel carrello:`, totalQuantity);
      return totalQuantity;
      
    } catch (error) {
      console.error('Errore nel recupero del carrello:', error);
      return 0;
    }
  }

  translateMessage(key, replacements = {}) {
    let message = window.purchaseLimitTranslations?.[key] || key;
    
    // Sostituisci i placeholder
    Object.keys(replacements).forEach(placeholder => {
      const regex = new RegExp(`{{\\s*${placeholder}\\s*}}`, 'g');
      message = message.replace(regex, replacements[placeholder]);
    });
    
    return message;
  }

  showLimitWarning(message) {
    // Rimuovi avvisi esistenti
    this.clearLimitWarning();

    // Trova dove inserire l'avviso
    const productForm = document.querySelector('[data-product-form], form[action*="/cart/add"]');
    if (productForm) {
      const warning = document.createElement('div');
      warning.className = 'purchase-limit-warning';
      warning.style.cssText = 'background: #fff3cd; color: #856404; padding: 10px; margin: 10px 0; border-radius: 4px; border: 1px solid #ffeaa7;';
      const attention = this.translateMessage('attention');
      warning.innerHTML = `<strong>${attention}:</strong> ${message}`;
      
      // Inserisci prima del pulsante aggiungi al carrello
      const addButton = productForm.querySelector('[type="submit"], [data-add-to-cart]');
      if (addButton) {
        addButton.parentNode.insertBefore(warning, addButton);
      } else {
        productForm.insertBefore(warning, productForm.firstChild);
      }
    }
  }

  clearLimitWarning() {
    const warnings = document.querySelectorAll('.purchase-limit-warning');
    warnings.forEach(warning => warning.remove());
  }

  updateQuantityMax(max) {
    const quantityInputs = document.querySelectorAll('[data-quantity-input], input[name="quantity"], .quantity__field, #product-quantity-input');
    console.log(`PurchaseLimits: Aggiornamento max a ${max} per ${quantityInputs.length} input`);
    
    quantityInputs.forEach(input => {
      input.max = max;
      input.setAttribute('max', max);
      
      if (parseInt(input.value) > max) {
        input.value = max;
        // Trigger evento change per aggiornare eventuali listener
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Aggiorna anche i pulsanti + e -
    const minusButtons = document.querySelectorAll('.quantity__minus');
    const plusButtons = document.querySelectorAll('.quantity__plus');
    
    plusButtons.forEach(btn => {
      const input = btn.parentElement.querySelector('input');
      if (input && parseInt(input.value) >= max) {
        btn.disabled = true;
      }
    });
  }

  disableAddToCart() {
    const addButtons = document.querySelectorAll('[type="submit"][name="add"], [data-add-to-cart], .btn--add-to-cart, button[name="add"]');
    console.log('PurchaseLimits: Disabilitazione pulsanti add to cart:', addButtons.length);
    
    addButtons.forEach(btn => {
      btn.disabled = true;
      const limitText = this.translateMessage('limitReachedButton');
      // Salva il testo originale per ripristinarlo
      if (!btn.dataset.originalText) {
        btn.dataset.originalText = btn.textContent;
      }
      btn.textContent = limitText;
    });

    // Disabilita anche la quantità
    const quantityInputs = document.querySelectorAll('[data-quantity-input], input[name="quantity"], .quantity__field, #product-quantity-input');
    quantityInputs.forEach(input => {
      input.disabled = true;
      input.value = 0;
      input.max = 0;
      input.setAttribute('max', '0');
    });
  }

  enableQuantityInput() {
    const quantityInputs = document.querySelectorAll('[data-quantity-input], input[name="quantity"], .quantity__field, #product-quantity-input');
    quantityInputs.forEach(input => {
      input.disabled = false;
      input.max = 999;
      input.setAttribute('max', '999');
    });

    const addButtons = document.querySelectorAll('[type="submit"][name="add"], [data-add-to-cart], .btn--add-to-cart, button[name="add"]');
    addButtons.forEach(btn => {
      btn.disabled = false;
      // Ripristina il testo originale se salvato
      if (btn.dataset.originalText) {
        btn.textContent = btn.dataset.originalText;
      } else if (btn.textContent === this.translateMessage('limitReachedButton')) {
        btn.textContent = 'Aggiungi al carrello';
      }
    });
  }

  async checkQuantityLimit(input) {
    if (!this.currentVariantId || !this.purchaseLimits[this.currentVariantId]) {
      return;
    }

    const limit = this.purchaseLimits[this.currentVariantId];
    const quantity = parseInt(input.value) || 0;
    
    console.log(`PurchaseLimits: Check quantità - input: ${quantity}, variante: ${this.currentVariantId}`);
    
    const currentInCart = await this.getVariantQuantityInCart(this.currentVariantId);
    const maxAllowed = Math.max(0, limit - currentInCart);
    
    if (quantity > maxAllowed) {
      input.value = maxAllowed;
      input.setAttribute('value', maxAllowed);
      
      const message = this.translateMessage('maxAllowed', { max: maxAllowed, limit });
      this.showLimitWarning(message);
      
      // Forza l'aggiornamento
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.purchaseLimits = new PurchaseLimits();
  });
} else {
  window.purchaseLimits = new PurchaseLimits();
}

// Reinizializza quando una sezione viene ricaricata
document.addEventListener('shopify:section:load', () => {
  window.purchaseLimits = new PurchaseLimits();
});